import { createAction } from '/@/store/utils';

export const setType = createAction('NITROGEN_RECOMMENDATION:SET_TYPE');
export const setPlantingDate = createAction('NITROGEN_RECOMMENDATION:SET_PLANTING_DATE');
export const setApplicationDate = createAction('NITROGEN_RECOMMENDATION:SET_APPLICATION_DATE');
export const setEstimatedApplicationDate = createAction('NITROGEN_RECOMMENDATION:SET_ESTIMATED_APPLICATION_DATE');
export const setSelectedHybrid = createAction('NITROGEN_RECOMMENDATION:SET_SELECTED_HYBRID');
export const setProductName = createAction('NITROGEN_RECOMMENDATION:SET_PRODUCT_NAME');
export const setNitrogenSource = createAction('NITROGEN_RECOMMENDATION:SET_NITROGEN_SOURCE');
export const setManagementZone = createAction('NITROGEN_RECOMMENDATION:SET_MANAGEMENT_ZONE');
export const setPhone = createAction('NITROGEN_RECOMMENDATION:SET_PHONE');
export const setCompanyName = createAction('NITROGEN_RECOMMENDATION:SET_COMPANY_NAME');
export const addManagementZone = createAction('NITROGEN_RECOMMENDATION:ADD_MANAGEMENT_ZONE');
export const removeManagementZone = createAction('NITROGEN_RECOMMENDATION:REMOVE_MANAGEMENT_ZONE');
export const setNewManagementZoneFiles = createAction('NITROGEN_RECOMMENDATION:SET_NEW_MANAGEMENT_ZONE_FILES');
export const setNitrogenRecommendation = createAction('NITROGEN_RECOMMENDATION:SET_NITROGEN_RECOMMENDATION');
export const setCropMonitoring = createAction('NITROGEN_RECOMMENDATION:SET_CROP_MONITORING');
export const removeAll = createAction('NITROGEN_RECOMMENDATION:REMOVE_ALL');
